import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Tabs, TabsProps } from "antd";
import React, { useMemo } from "react";
import ContactInformation from "../ServiceRecords/ContactInformation";

const UsedCar = ({ stData = {} as any, stChange = (data: any) => {} }) => {
  interface CarData {
    brand: string;
    model: string;
    variant: string;
    vehicle: string;
    name: string;
    plate: string;
    frame: string;
    license: string;
    trademark: string;
  }

  const germanCarData: CarData[] = [
    {
      brand: "BMW",
      model: "Nhóm xe du lịch",
      variant: "New Carnival 2.2D Signature 7S",
      vehicle: "Đang dùng",
      name: "Tấn Tài",
      plate: "",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },

    {
      brand: "Audi",
      model: "Nhóm xe tải bus",
      variant: "New Carnival 2.2D Signature 7S",
      vehicle: "Đang dùng",
      name: "WAUF2AF25LN789012",
      plate: "",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
    {
      brand: "Audi",
      model: "Nhóm xe du lịch",
      variant: "New Carnival 2.2D Signature 7S",
      vehicle: "Đang dùng",
      name: "WAUF2AF25LN789015",
      plate: "",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
    {
      brand: "Audi",
      model: "Nhóm xe tải bus",
      variant: "SUV",
      vehicle: "Đang dùng",
      name: "WA1BNAFY3K2012345",
      plate: "",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
    {
      brand: "Volkswagen",
      model: "Nhóm xe du lịch",
      variant: "SUV",
      vehicle: "Đang dùng",
      name: "WVGZZZ5NZMW123456",
      plate: "",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
    {
      brand: "Volkswagen",
      model: "Nhóm xe tải bus",
      variant: "New Carnival 2.2D Signature 7S",
      vehicle: "Đang dùng",
      name: "WVWWZZ3CZJE123456",
      plate: "51H-12333",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
    {
      brand: "Porsche",
      model: "Nhóm xe tải bus",
      variant: "SUV",
      vehicle: "Đang dùng",
      name: "WP1AB2A5XLB123456",
      plate: "43A-12321",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
    {
      brand: "Porsche",
      model: "Nhóm xe tải bus",
      variant: "Coupe",
      vehicle: "Đang dùng",
      name: "WP0ZZZ99ZKS123456",
      plate: "99A-91111",
      frame: "RNHA43TNART090850",
      license: "65C22983",
      trademark: "KIA",
    },
  ];



  const actionColumn: ColDef = {
    headerName: "Hành động",
    cellClass: "font-medium",
    field: "action",
    colId: "action",
    cellRenderer: (params: any) => {
      // Nếu là group row (hãng hoặc dòng) thì không hiển thị nút
      if (params.node.group) {
        return null;
      }

      const id = params.data?.id;
      return (
        <div className="d-flex gap-4 justify-center align-center h-full">
          <EyeOutlined
            className="text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer"
          // onClick={() => gInfoCarLine(id)}
          />
          <EditOutlined
            className="text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer"
          // onClick={() => gInfoCarLine(id, false)}
          />
          <DeleteOutlined
            className="text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer"
          // onClick={() => openModalDelete(Number(id))}
          />
        </div>
      );
    },
    flex: 1,
  };

  const columnDefs: ColDef[] = [
    {
      field: "own_vehicle_brand",
      cellClass: "font-medium",
      headerName: "Hãng xe",
      rowGroup: true,
      rowGroupIndex: 0,
      hide: true,
    },
    {
      field: "own_vehicle_name",
      headerName: "Tên xe",
      cellClass: "font-medium",
      cellRenderer: (params: any) => {
        const node = params.node;

        if (node?.group) {
          const leaves = node.allLeafChildren ?? [];
          const unique = (pick: (d: any) => any) =>
            new Set(leaves.map((c: any) => pick(c?.data))).size;

          if (node.level === 0) {
            // Dòng xe → đếm số hãng
            return (
              <span style={{ color: "#096DD9", fontWeight: 500 }}>
                Số xe: {leaves.length}
              </span>
            );
          }
        }

        // Hàng lá → hiển thị tên phiên bản
        return params.data?.own_vehicle_name;
      },
    },

    { field: "own_chassis_no", headerName: "Số khung" },
    { field: "own_color_name", headerName: "Màu xe" },
    { field: "own_engine_no", headerName: "Số máy" },
    { field: "own_made_year", headerName: "Năm sản xuất" },
    { field: "own_number_plate", headerName: "Biển số" },
  ];

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
      minWidth: 200,
      sortable: true,
      resizable: true,
    };
  }, []);

  const autoGroupColumnDef = useMemo<ColDef>(
    () => ({
      headerName: "Hành động",
      minWidth: 320,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: {
        suppressCount: true,
        suppressDoubleClickExpand: true,
        innerRenderer: (params: ICellRendererParams) => {
          const node: any = params.node;
          const label = params.value;

          if (node.group) {
            return <span>{`${label}`}</span>;
          }

          // Hàng lá (xe): nhãn + nút hành động
          const id = params.data?.id;

          const onView = (e: React.MouseEvent) => {
            e.stopPropagation();
          };
          const onEdit = (e: React.MouseEvent) => {
            e.stopPropagation();
          };
          const onDelete = (e: React.MouseEvent) => {
            e.stopPropagation();
          };

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span>{label}</span>
              <div
                onClick={(e) => e.stopPropagation()}
                style={{ display: "flex", gap: 13 }}
              >
                <EyeOutlined
                  className="text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer fs-14 border-8px"
                  onClick={() => {
                    stChange({ xesudung_show: params.data})
                  }}
                />
              </div>
            </div>
          );
        },
      },
    }),
    []
  );
  return (
    <>
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
        style={{ width: "100%" }}
      >
        <AgGridReact
          rowData={stData.xesudung || []}
          columnDefs={columnDefs}
          rowHeight={55}
          domLayout="autoHeight"
          className="my-auto-height-grid"
          defaultColDef={defaultColDef}
          autoGroupColumnDef={autoGroupColumnDef}
          groupDefaultExpanded={0} // 0: đóng mặc định, -1: mở tất cả
          animateRows={true}
        // QUAN TRỌNG: bỏ các cấp nhóm chỉ có 1 con
        />
      </div>

    </>
  );
};
export default UsedCar;
